var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.view,{tag:"component",on:{"abbort":function($event){_vm.$emit('abbort')},"stepdone":function($event){_vm.$emit('stepdone')}}})}
var staticRenderFns = []

export { render, staticRenderFns }